// extracted by mini-css-extract-plugin
export default {"wrapper":"SettlementRulesDetails_wrapper__ZDcLM","col":"SettlementRulesDetails_col__7MEGL"};